import _Promise from 'babel-runtime/core-js/promise';
import { withServiceImplementation } from '@myaccount/utils';


import IDropdown from './DropdownInterface';

export default withServiceImplementation(IDropdown, {
  open: function open(props) {
    return function (event) {
      return props.open(event);
    };
  },

  close: function close(props) {
    return function () {
      props.close();
      return _Promise.resolve('[IDropdown] close success');
    };
  },
  show: function show(props) {
    return function () {
      props.show();
      return _Promise.resolve('[IDropdown] open success');
    };
  },
  hide: function hide(props) {
    return function () {
      props.hide();
      return _Promise.resolve('[IDropdown] close success');
    };
  }
});